import { Divider, Stack, Text } from "@mantine/core";
import React from "react";
import { ReportChaptersTree } from "../../../../components/ReportChapterTree/ReportChapterTree";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { thunkAkustikkKapittelToggled } from "./akustikkRapportThunks";

export const AkustikkKapitler: React.FC = () => {
  const dispatch = useAppDispatch();
  const edited = useAppSelector((s) => s.reportReducer.editedData[401]);
  if (!edited) return null;

  return (
    <Stack gap="xs">
      <ReportChaptersTree
        titleNode={
          <Divider
            label={
              <Text fz="md" fw={600}>
                Kapitler
              </Text>
            }
          />
        }
        chapters={edited.kapitler}
        onToggle={(chapterId, next) => dispatch(thunkAkustikkKapittelToggled(chapterId, next))}
        toggleDescendantsOnParentToggle={false}
        renderLabel={(n) => <Text>{n.text ?? n.title}</Text>}
        hideEmptyChildren
        isDisabled={(n) => n.isDisabled === true}
      />
    </Stack>
  );
};
